// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__C_16F","requiredAsterisk":"Info_requiredAsterisk__3np7H"};